import { c as _c } from "react/compiler-runtime";
import Image, { type ImageProps } from 'next/image';
import Carousel from '../Carousel';
import styles from './TestimonialCarousel.module.scss';
import { maxWidthBelow } from '../tokens/breakpoints';
export interface TestimonialSlide {
  quote: string;
  /** The attribution under the quote; also the name of the slide's page dot. */
  byline: string;
  /** A second attribution line under the byline (the student's program),
   * in the body weight. */
  bylineDetail?: string;
  photo: ImageProps['src'];
  photoAlt?: string;
}
export interface TestimonialCarouselProps {
  slides: TestimonialSlide[];
  /** The carousel's accessible name. Defaults to "Student testimonials". */
  label?: string;
  /**
   * `dots` (the default; Phase 6, R8): one page dot per testimonial in the
   * control row, between previous and next (on a line of their own above
   * them when they do not fit), each named by its byline. No timer: the
   * testimonials never auto-advance. `none`: previous and next alone, for a
   * page that must opt out.
   */
  indicators?: 'dots' | 'none';
}
const CONTROL_LABELS = {
  previous: 'Previous testimonial',
  next: 'Next testimonial'
};

/**
 * Student testimonials on the Helios Carousel (`card`): one quote panel with
 * its photo per slide, the neighbours peeking, the page dots and
 * previous/next below (R8: every testimonial carousel shows the dots). No
 * quote mark (Phase 4 Q5): the quote is set in the display tuple, the byline
 * in the body tuple.
 */
function TestimonialCarousel(t0) {
  const $ = _c(6);
  const {
    slides,
    label: t1,
    indicators: t2
  } = t0;
  const label = t1 === undefined ? "Student testimonials" : t1;
  const indicators = t2 === undefined ? "dots" : t2;
  let t3;
  if ($[0] !== slides) {
    t3 = slides.map(_temp);
    $[0] = slides;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== indicators || $[3] !== label || $[4] !== t3) {
    t4 = <Carousel variant="card" label={label} indicators={indicators} controlLabels={CONTROL_LABELS} slides={t3} />;
    $[2] = indicators;
    $[3] = label;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp(slide, index) {
  return {
    key: `${slide.byline}-${index}`,
    dotLabel: slide.byline,
    content: <div className={styles["helios-testimonial-carousel__panel"]}><div className={styles["helios-testimonial-carousel__text"]}><p className={styles["helios-testimonial-carousel__quote"]}>{slide.quote}</p><p className={styles["helios-testimonial-carousel__byline"]}><strong>{slide.byline}</strong>{slide.bylineDetail ? <span className={styles["helios-testimonial-carousel__byline-detail"]}>{slide.bylineDetail}</span> : null}</p></div><div className={styles["helios-testimonial-carousel__photo"]}><Image src={slide.photo} alt={slide.photoAlt ?? slide.byline} fill={true} sizes={`${maxWidthBelow("xs")} 100vw, 545px`} /></div></div>
  };
}
export default TestimonialCarousel;